import { createQueue } from '@/shared/config/bullmq.config.js';

export const UnitQueue = createQueue('unit');

export enum UnitJobType {
  BULK_UPLOAD = 'bulk_upload',
}